/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Component State Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { componentsState: componentsStateEndPoints } = endpoints;

class ComponentsStateService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get Nephro Master state
   * @returns {}
   */
  getNephroMasterState = async () => {
    const url = componentsStateEndPoints.nephroMasterState;
    return this.http.get(url);
  };

  /**
   * Get Nephro Auth state
   * @returns {}
   */
  getNephroAuthState = async () => {
    const url = componentsStateEndPoints.nephroAuthState;
    return this.http.get(url);
  };

  /**
   * Get state information about service
   * @returns { Object } - Get Nephro Integrator state information
   */
  getNephroIntegratorState = async () => {
    const url = componentsStateEndPoints.nephroIntegratorState;
    return this.http.get(url);
  };

  /**
   * Get state information about service
   * @returns { Object } - Get Nephro Calendar state information
   */
  getNephroCalendarState = async () => {
    const url = componentsStateEndPoints.nephroCalendarState;
    return this.http.get(url);
  };

  /**
   * Get state information about service
   * @returns { Object } - Get Nephro Media state information
   */
  getNephroMediaState = async () => {
    const url = componentsStateEndPoints.nephroMediaState;
    return this.http.get(url);
  };

  /**
   * Get state information about service
   * @returns { Object } - Get Nephro Common state information
   */
  getNephroCommonState = async () => {
    const url = componentsStateEndPoints.nephroCommonState;
    return this.http.get(url);
  };
}

export default new ComponentsStateService(externalConnector);
